/** 登录页写入 sessionStorage 的 user_info 可能含超大 base64（认证图等），需瘦身后再存。 */

export function normalizeUserHeadImg(v) {
  if (v == null || typeof v !== 'string') return v
  const t = v.trim()
  if (!t) return ''
  if (t.startsWith('data:image') || /^https?:\/\//i.test(t)) return t
  if (t.startsWith('/') || t.startsWith('./')) return t
  if (t.length > 80 && /^[A-Za-z0-9+/=\s]+$/.test(t)) {
    return 'data:image/png;base64,' + t.replace(/\s/g, '')
  }
  return t
}

function compactHeadImg(head) {
  const t = String(head || '').trim()
  if (!t) return ''
  if (t.startsWith('data:image')) return ''
  if (t.startsWith('/') || /^https?:\/\//i.test(t)) return t
  if (t.length <= 2048) return t
  return ''
}

/** 去掉登录响应中的大体积媒体字段，避免前端多余处理。 */
export function slimLoginUserInfo(userInfo) {
  if (!userInfo || typeof userInfo !== 'object') return userInfo
  const next = { ...userInfo }
  delete next.auto_img
  const head = String(next.user_head_img || '').trim()
  if (head.startsWith('data:image') || head.length > 2048) {
    next.user_head_img = ''
  }
  return next
}

function buildPayload(userInfo, firstLogin) {
  const info = {
    user_id: String((userInfo && userInfo.user_id) || '').trim(),
    user_phone: (userInfo && userInfo.user_phone) || '',
    user_head_img: '',
    username: (userInfo && userInfo.username) || '',
    is_auth: userInfo && userInfo.is_auth,
    is_auth_label: (userInfo && userInfo.is_auth_label) || '',
    first_login: !!firstLogin,
    auto_fail_message: (userInfo && userInfo.auto_fail_message) || '',
  }
  if (userInfo && typeof userInfo === 'object' && Object.prototype.hasOwnProperty.call(userInfo, 'user_head_img')) {
    info.user_head_img = compactHeadImg(normalizeUserHeadImg(userInfo.user_head_img))
  }
  return info
}

function verifyStoredUserId(uid) {
  try {
    const raw = sessionStorage.getItem('loginUser')
    if (!raw) return false
    const parsed = JSON.parse(raw)
    return String((parsed && parsed.user_id) || '').trim() === uid
  } catch (_) {
    return false
  }
}

/**
 * 保存登录会话。返回 { ok, message? }；成功时至少保证 user_id 可被路由守卫识别。
 */
export function saveLoginSession(userInfo, firstLogin) {
  const uid = String((userInfo && userInfo.user_id) || '').trim()
  if (!uid) {
    return { ok: false, message: '登录成功但缺少用户标识，无法进入个人中心' }
  }

  const payload = buildPayload(userInfo, firstLogin)
  const attempts = [payload]

  for (let i = 0; i < attempts.length; i++) {
    try {
      sessionStorage.setItem('loginUser', JSON.stringify(attempts[i]))
      if (verifyStoredUserId(uid)) {
        try {
          sessionStorage.setItem('h5_first_login', payload.first_login ? '1' : '0')
        } catch (_) {
          /* ignore */
        }
        return { ok: true }
      }
    } catch (_) {
      /* try slimmer payload */
    }
  }

  return {
    ok: false,
    message: '登录状态保存失败，请关闭无痕模式后重试，或清理浏览器缓存后再登录',
  }
}

const CERT_SNAPSHOT_PENDING_KEY = 'h5_cert_snapshot_pending'

/** 登录后认证图需从服务端拉取时标记，个人中心加载完成前不提示「认证图片加载失败」。 */
export function markCertSnapshotPending() {
  try {
    sessionStorage.setItem(CERT_SNAPSHOT_PENDING_KEY, '1')
  } catch (_) {
    /* ignore */
  }
}

export function consumeCertSnapshotPending() {
  try {
    if (sessionStorage.getItem(CERT_SNAPSHOT_PENDING_KEY) === '1') {
      sessionStorage.removeItem(CERT_SNAPSHOT_PENDING_KEY)
      return true
    }
  } catch (_) {
    /* ignore */
  }
  return false
}

export function hasLoginSession() {
  try {
    const raw = sessionStorage.getItem('loginUser')
    if (!raw) return false
    const u = JSON.parse(raw)
    return !!(u && typeof u === 'object' && String(u.user_id || '').trim())
  } catch (_) {
    return false
  }
}

/** 清空登录会话（loginUser、首登标记；顺带清理旧版头像缓存键） */
export function clearLoginSession(userId) {
  const uid = String(userId || '').trim()
  try {
    sessionStorage.removeItem('loginUser')
    sessionStorage.removeItem('h5_first_login')
    if (uid) {
      sessionStorage.removeItem(`h5_user_avatar:${uid}`)
    }
  } catch (_) {
    /* ignore */
  }
}
